import React, { Component } from "react";
import { withFirebase } from "../Firebase";
import { Redirect } from "react-router-dom";
import Repeat from "react-repeat-component";
import { Grid, Row, Col } from "react-flexbox-grid";
import { Button } from "@material-ui/core";
import { InputGroup } from "@blueprintjs/core";

const day_array = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"];

class AllTeamMemberPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availability: [],
    };
  }

  async componentDidMount() {
    let { availability } = this.state;
    await this.props.firebase.db
      .collection("team_members")
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          if (doc.data().hasOwnProperty("availability")) {
            availability.push({
              name: doc.data().name,
              availability: this.parseObjectIntoArray(doc.data().availability),
            });
          }
        });
      });
    this.setState({ availability });
    console.log(availability);
  }

  parseNestedArrayIntoObject(arr) {
    //our nested arrays have the following format:
    // [[{start_time : "xx:xx", end_time : "xx:xx"},{{start_time : "xx:xx", end_time : "xx:xx"}}],[{}], etc..]
    // to parse it so firebase will accept it, we will transform it into the following object of arrays:
    //{
    //  0:[{start_time: "xx:xx",end_time : "xx:xx"},{start_time: "xx:xx", end_time : "xx:xx"}],
    //  1:[{start_time: "xx:xx",end_time : "xx:xx"},{start_time: "xx:xx",end_time : "xx:xx"}]
    //}
    console.log(arr);
    let arr_object = {};
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === null) {
        continue;
      }
      arr_object[i] = [];
      for (let j = 0; j < arr[i].length; j++) {
        arr_object[i].push(arr[i][j]);
      }
    }
    console.log(arr_object);
    return arr_object;
  }

  parseObjectIntoArray(arr_object) {
    // needed to parse the firestore object back into an array so working with it is ez pz
    // for explanation, see the comments on parseNestedArrayIntoObject, and then reverse it uwu
    let arr = [null, null, null, null, null];
    for (let i = 0; i < arr.length; i++) {
      if (arr_object.hasOwnProperty(i)) {
        arr[i] = [];
        for (let j = 0; j < arr_object[i].length; j++) {
          arr[i].push(arr_object[i][j]);
        }
      } else {
        continue;
      }
    }
    return arr;
  }

  render() {
    let { availability } = this.state;
    return (
      <Grid>
        <Repeat times={availability.length} key="outer_repeat">
          {(i) => {
            return (
              <Row key={"outer-row-" + i}>
                {availability[i].name}
                <Col key={"outer-col-" + i} xs>
                  <Repeat
                    times={availability[i].availability.length}
                    key={"inner repeat" + i}
                  >
                    {(j) => {
                      if (availability[i].availability[j] != null) {
                        return (
                          <Col key={"inner-col-" + j} xs>
                            <Row key={"inner-row-" + j}>
                              {day_array[j]}
                              <Repeat
                                times={availability[i].availability[j].length}
                                key={"the-most-innerest-repeat" + j}
                              >
                                {(k) => {
                                  return (
                                    <Col key={"the-most-innerest-col-" + k} xs>
                                      {availability[i].availability[j][k]
                                        .start_time +
                                        " - " +
                                        availability[i].availability[j][k]
                                          .end_time}
                                    </Col>
                                  );
                                }}
                              </Repeat>
                            </Row>
                          </Col>
                        );
                      }
                    }}
                  </Repeat>
                </Col>
              </Row>
            );
          }}
        </Repeat>
      </Grid>
    );
  }
}
export default withFirebase(AllTeamMemberPage);
